import React, { useEffect } from 'react';

import HeroCarousel from './home/HeroCarousel';
import AboutSection from './home/AboutSection';
import BenefitsSection from './home/BenefitsSection';
import ServicesOverviewSection from './home/ServicesOverviewSection';
import ServiceTabsSection from './home/ServiceTabsSection';
import WiziBoardPreviewSection from './home/WiziBoardPreviewSection';
import WiziTalkPreviewSection from './home/WiziTalkPreviewSection';
import WiziRankSection from './home/WiziRankSection';
import CallToActionSection from './home/CallToActionSection';
import TestimonialSection from './home/TestimonialSection';
import FAQSection from './home/FAQSection';



// Add type declarations for owl carousel
declare global {
  interface JQuery {
    owlCarousel(options?: any): JQuery;
  }
}

const Home: React.FC = () => {


  useEffect(() => {
    // Service-carousel
    $(".service-carousel").owlCarousel({
      autoplay: true,
      smartSpeed: 2000,
      center: false,
      dots: false,
      loop: true,
      margin: 25,
      nav: true,
      navText: [
        '<i class="bi bi-arrow-left"></i>',
        '<i class="bi bi-arrow-right"></i>'
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        576: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });


    // testimonial carousel
    $(".testimonial-carousel").owlCarousel({
      autoplay: true,
      smartSpeed: 1500,
      center: false,
      dots: true,
      loop: true,
      margin: 25,
      nav: false,
      navText: [
        '<i class="fa fa-angle-right"></i>',
        '<i class="fa fa-angle-left"></i>'
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1
        },
        576: {
          items: 1
        },
        768: {
          items: 1
        },
        992: {
          items: 1
        },
        1200: {
          items: 2
        }
      }
    });
  }, []);
  return (
    <>

      <HeroCarousel />
      <AboutSection />
      <BenefitsSection />
      <ServicesOverviewSection />
      <ServiceTabsSection />
      <WiziBoardPreviewSection />
      <WiziTalkPreviewSection />
      <WiziRankSection />
      <CallToActionSection />
      <TestimonialSection />
      <FAQSection />

    </>
  );
};

export default Home;
